/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */


import {L10nTranslationService} from 'angular-l10n';
import {
    ColumnSettings,
    DateColumnSettings,
    NumberColumnSettings,
    TextColumnSettings
} from '@yasc/yasc-material-components';
import {BookingRes} from '../contracts/v0/fibu/booking.contract';
import {FBookingSourceType} from '../enums/fibu.enums';

export function fibuHiddenDefaultColumns(translation: L10nTranslationService): ColumnSettings<BookingRes>[] {
    return [
        new TextColumnSettings('supportingDocuments', {
            yascLabel: translation.translate('generalVouchers'),
            yascInnerHtml: true,
            yascHidden: true,
            yascWidth: 2,
            yascDisplayFn: (val:BookingRes) => {
                if (val.supportingDocuments.length > 0) {
                    return val.supportingDocuments.map(x => {
                        `<a [href]="${x.link}">${x.displayName}</a>`
                    })
                }
                return "";
            }
        }),
        new TextColumnSettings('createdBy', {
            yascLabel: translation.translate('generalCreatedBy'),
            yascHidden: true,
            yascWidth: 2,
        }),
    ];
}

export function fibuViewDefaultColumns(translation: L10nTranslationService): ColumnSettings<BookingRes>[] {

    return [
        new DateColumnSettings('receiptDate', {
            yascLabel: translation.translate('generalDate'),
            yascWidth: 1
        }),
        new TextColumnSettings('receiptNumber', {
            yascLabel: translation.translate('fibuBookingNumber'),
            yascWidth: 1
        }),
        new TextColumnSettings('purpose', {
            yascLabel: translation.translate('fibuBookingText'),
            yascWidth: 3
        }),
        new NumberColumnSettings('source', {
            yascDisplayFn: (val:BookingRes) => {
                return translation.translate(FBookingSourceType[val.source].toString())
            },
            yascLabel: translation.translate('fibuBookingSource'),
            yascWidth: 1,
        }),
    ]

}

export function fibuSplitColumns(translation: L10nTranslationService): ColumnSettings<BookingRes>[] {

    return [
        new TextColumnSettings('fibuBookingCredit', {
            yascLabel: translation.translate('fibuBookingCredit'),
            yascInnerHtml: true,
            yascJustifyContent: "unset",
            yascDisplayFn: (val:BookingRes) => {
                if (val.creditAccountId != undefined) {
                    return `<span style="text-align: left;">${val.creditAccountCode!.toString()}</span>`;
                }

                return `<div>
                        ${val.splits.map(x => `<div>
                        <span style="text-align: left;">${x.creditAccountCode}</span>    |
                        <span style="text-align: right;">${x.total.toFixed(2)} €</span></div>`).join('')}
                        </div>`;
            }
        }),
        new TextColumnSettings('fibuBookingDebit', {
            yascLabel: translation.translate('fibuBookingDebit'),
            yascJustifyContent: "unset",
            yascInnerHtml: true,
            yascDisplayFn: (val: BookingRes) => {
                if (val.debitAccountId != undefined) {
                    return `<span style="text-align: left;">${val.debitAccountCode!.toString()}</span>`;
                }

                return `<div>
                        ${val.splits.map(x => `<div>
                        <span style="text-align: left;">${x.debitAccountCode}</span>    |
                        <span style="text-align: right;">${x.total.toFixed(2)} €</span></div>`).join('')}
                        </div>`;
            }
        })
    ];


}
